import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function Waitlist() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Connect to your email/waitlist provider here
    // - Mailchimp, ConvertKit, Tally, Google Forms, or custom backend
    console.log('Waitlist submission:', form);
    setSubmitted(true);
  };
  return <section id="waitlist" className="bg-paper py-28 md:py-36 px-6 md:px-10 border-t border-ink/10" data-id="element-104">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 md:gap-16 items-start" data-id="element-105">
        <div data-id="element-106">
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="font-serif-display text-3xl md:text-5xl leading-[1.1] text-ink" data-id="element-107">
            Come <span className="italic" data-id="element-108">with us.</span>
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.3
        }} style={{
          transformOrigin: 'left'
        }} className="mt-8 w-10 h-px bg-ink/40" data-id="element-109" />
          <p className="mt-8 text-ink-soft text-[15px] leading-[1.85] max-w-md" data-id="element-110">
            Upcoming experiences coming soon. <br data-id="element-111" />
            Join the waitlist to be the first to know.
          </p>
        </div>

        <div data-id="element-112">
          {submitted ? <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6
        }} className="border border-ink/15 p-10 text-center" data-id="element-113">
              <p className="eyebrow mb-4" data-id="element-114">You're in</p>
              <p className="font-serif-display italic text-ink text-2xl md:text-3xl" data-id="element-115">
                We'll be in touch — quietly.
              </p>
            </motion.div> : <motion.form initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} onSubmit={handleSubmit} className="space-y-4" data-id="element-116">
              <input type="text" required placeholder="Name" value={form.name} onChange={e => setForm({
            ...form,
            name: e.target.value
          })} className="w-full bg-paper border border-ink/20 px-5 py-4 text-ink placeholder-ink/40 outline-none focus:border-ink transition-colors" data-id="element-117" />
              <input type="email" required placeholder="Email" value={form.email} onChange={e => setForm({
            ...form,
            email: e.target.value
          })} className="w-full bg-paper border border-ink/20 px-5 py-4 text-ink placeholder-ink/40 outline-none focus:border-ink transition-colors" data-id="element-118" />
              <button type="submit" className="w-full px-10 py-4 bg-ink text-bone text-[11px] uppercase tracking-[0.32em] hover:bg-accent transition-colors duration-500" data-id="element-119">
                Join the Waitlist
              </button>
              <p className="pt-2 text-center eyebrow !text-muted" data-id="element-120">
                No spam. Just first access and updates.
              </p>
            </motion.form>}
        </div>
      </div>
    </section>;
}